import React, { createContext, useState, useContext, useEffect } from 'react';

const PartnerContext = createContext();

export const usePartners = () => useContext(PartnerContext);

export const PartnerProvider = ({ children }) => {
    const [partners, setPartners] = useState(() => {
        const savedPartners = localStorage.getItem('b2b-partners');
        return savedPartners ? JSON.parse(savedPartners) : [
            {
                id: 1,
                companyName: 'Vinay and sons',
                contactPerson: 'Vinay Chauhan',
                contactNumber: '6777677767',
                gstin: '22AAAAA0000A1Z5',
                drugLicense1: 'UP1233455677123',
                drugLicense2: 'UP1233455677123',
                outstandingBills: 9812,
                orders: 512,
                status: 'active',
                avatar: 'https://api.dicebear.com/7.x/initials/svg?seed=VS'
            },
            {
                id: 2,
                companyName: 'DAN BA Company',
                contactPerson: 'Dilip Singh',
                contactNumber: '6888677767',
                gstin: '22AAAAA0000A1Z5',
                drugLicense1: 'UP1233455677123',
                drugLicense2: 'UP1233455677123',
                outstandingBills: 12987,
                orders: 815,
                status: 'active',
                avatar: 'https://api.dicebear.com/7.x/initials/svg?seed=DB'
            },
            {
                id: 3,
                companyName: 'BACF Company',
                contactPerson: 'Jessica Sinha',
                contactNumber: '4777789009',
                gstin: '22AAAAA0000A1Z5',
                drugLicense1: 'UP1233455677123',
                drugLicense2: 'UP1233455677123',
                outstandingBills: 9899,
                orders: 512,
                status: 'active',
                avatar: 'https://api.dicebear.com/7.x/initials/svg?seed=BC'
            }
        ];
    });

    useEffect(() => {
        localStorage.setItem('b2b-partners', JSON.stringify(partners));
    }, [partners]);

    const addPartner = (newPartner) => {
        setPartners(prev => [
            {
                ...newPartner,
                id: Date.now(),
                status: 'active',
                outstandingBills: 0,
                orders: 0,
                avatar: newPartner.companyLogo || `https://api.dicebear.com/7.x/initials/svg?seed=${newPartner.companyName}`
            },
            ...prev
        ]);
    };

    const updatePartner = (id, updatedData) => {
        setPartners(prev =>
            prev.map(p => (p.id === parseInt(id) ? {
                ...p,
                ...updatedData,
                avatar: updatedData.companyLogo || p.avatar
            } : p))
        );
    };

    const addShippingAddress = (partnerId, newAddress) => {
        setPartners(prev =>
            prev.map(p => {
                if (p.id === parseInt(partnerId)) {
                    const addresses = p.shippingAddresses || [];
                    return { ...p, shippingAddresses: [...addresses, { ...newAddress, id: Date.now() }] };
                }
                return p;
            })
        );
    };

    const deleteShippingAddress = (partnerId, addressId) => {
        setPartners(prev =>
            prev.map(p => {
                if (p.id === parseInt(partnerId)) {
                    const addresses = p.shippingAddresses || [];
                    return { ...p, shippingAddresses: addresses.filter(a => a.id !== addressId) };
                }
                return p;
            })
        );
    };

    const togglePartnerStatus = (id) => {
        setPartners(prev =>
            prev.map(p =>
                p.id === id ? { ...p, status: p.status === 'active' ? 'inactive' : 'active' } : p
            )
        );
    };

    return (
        <PartnerContext.Provider value={{ partners, addPartner, updatePartner, addShippingAddress, deleteShippingAddress, togglePartnerStatus }}>
            {children}
        </PartnerContext.Provider>
    );
};
